import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";

export const UploadAudioFileApi = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await AxiosInstance.post(
        apiRoutes.adminAudioUpload,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response;
};

export const AddAudioApi = async (payload: any) => {
    const response = await AxiosInstance.post(
        apiRoutes.adminAudio,
        payload
    );
    return response;
};

export const ListAudioApi = async () => {
    const response = await AxiosInstance.get(apiRoutes.adminAudio);
    return response;
};

export const DeleteAudioApi = async (id: string) => {
    const response = await AxiosInstance.delete(
        `${apiRoutes.adminAudio}/${id}`
    );
    return response;
};
export const setDefaultAudioApi = async (audioId: string) => {
    const response = await AxiosInstance.post(
        apiRoutes.adminAudioDefault,
        { audioId }
    );
    return response;
};
